/**
 * Author：brand
 * Creation Time：2019-05-11 09:12
 * Email：brandhuang@qq.com
 */
import api from '@/api/index'

const state = {
  sidebar: {
    clapse: sessionStorage.getItem('sidebarStatus') ? !!+sessionStorage.getItem('sidebarStatus') : false
  },
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.clapse = !state.sidebar.clapse
    if (state.sidebar.clapse) {
      sessionStorage.setItem('sidebarStatus', 1)
    } else {
      sessionStorage.setItem('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {

  },
  TOGGLE_DEVICE: (state, device) => {

  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
